(function () {
  function applyCartImageSpanStyles(container, setPosition) {
    container.querySelectorAll(':scope > span').forEach(function (span) {
      span.style.setProperty('width', '70px', 'important');
      span.style.setProperty('height', '70px', 'important');
    });

    if (setPosition) {
      container.style.setProperty('position', 'relative', 'important');
    }
  }

  function applyCartImageStyles() {
    document.querySelectorAll('.ocu-cart-line-item-image').forEach(function (el) {
      applyCartImageSpanStyles(el, true);
    });

    document.querySelectorAll('.cart-item-image').forEach(function (el) {
      applyCartImageSpanStyles(el, false);
    });
  }

  applyCartImageStyles();

  if (typeof MutationObserver !== 'undefined') {
    new MutationObserver(applyCartImageStyles).observe(document.body, {
      childList: true,
      subtree: true
    });
  }
})();
